import { createBrowserRouter } from "react-router";
import App from "../App";

export const router = createBrowserRouter([
  {
    path: "/",
    children: [
      { index: true, element: <App /> },
    ],
  },
  {
    path: "/cti",
    children: [
      { index: true, element: <App /> },
    ],
  },
]);
